// extracted by mini-css-extract-plugin
export default {"table_section":"styles_table_section__o1Zyv"};